import React, { Component } from 'react';
import axios from '../global/axios';
import LoadingIndicator from '../global/loading_indicator/loading_indicator';
import AppSection from './app_section';

class DashboardLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: null,
        };
    }

    componentDidMount() {
        axios.get('/dash/summary.json')
            .then(res => this.setState({ data: res.data, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    render() {
        const { loading, data } = this.state;

        if (loading) {
            return <LoadingIndicator />;
        }

        if (!data) {
            return (
                <div className="max-w-6xl mx-auto p-6">
                    <p className="text-gray-500">Unable to load dashboard.</p>
                </div>
            );
        }

        const { user, apps } = data;

        return (
            <div className="max-w-6xl mx-auto p-6">
                <h1 className="text-2xl font-bold text-gray-800 mb-1">
                    Welcome, {user.first_name}
                </h1>
                <p className="text-gray-500 mb-8">{user.organization_name}</p>

                {apps.length === 0 && (
                    <div className="bg-gray-100 rounded-3xl p-8 text-center">
                        <p className="text-gray-500">No apps enabled yet.</p>
                        <a href="/billing" className="text-sm text-blue-500 mt-2 inline-block">
                            Manage subscriptions
                        </a>
                    </div>
                )}

                {apps.map(app => (
                    <AppSection key={app.short_name} app={app} />
                ))}
            </div>
        );
    }
}

export default DashboardLayout;
